import type { CombinedDataStoreState, LoadedVaultWithPnl, MorphoMarketDataSet, } from "@types";
import { getMarketPositions, } from "./getMarketPositions";




/**
 * Applies Morpho market data to a vault
 * @param store - The combined data store state
 * @param vault - The vault to apply Morpho market data to
 * @returns The vault with Morpho market data
 */

export const applyMorphoMarketData = async ( store: CombinedDataStoreState, vault: LoadedVaultWithPnl, ): Promise<LoadedVaultWithPnl & { morpho: MorphoMarketDataSet }> => {

	try {

		const { wallet, vaults: { available, }, } = store;
		if(!wallet || !wallet.address) {
			return { ...vault, morpho: { position: null, engaged: false, ready: false, error: new Error("wallet address not set"), }, };
		}
		const all_data = await getMarketPositions({ wallet: { address: wallet.address, }, vaults: available, });
		const position = all_data?.[vault.symbol];
		if(position) {
			return { ...vault, morpho: { position, engaged: true, ready: true, }, };
		}

		return { ... vault, morpho: { position: null, engaged: false, ready: true, }, };

	}
	catch(err) {

		console.error(`getMorphoMarketData failed for vault ${vault.symbol} - ${err instanceof Error ? err.message : "without error instance"}`);
		return { ...vault, morpho: { position: null, engaged: false, ready: false, error: err instanceof Error ? err : new Error("unknown error"), }, };

	}

}
